/**
 * Location descriptions (ERI-2853) are plain text. A blank line separates
 * paragraphs; anything else is kept as written.
 */
export function descriptionToParagraphs(description: string | null | undefined): string[] {
  if (!description) return [];
  return description
    .split(/\n\s*\n/)
    .map((p) => p.replace(/\s*\n\s*/g, ' ').trim())
    .filter((p) => p.length > 0);
}
